export const phoneRegx = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/
export const addressMaxLengthRegex = /^.{0,46}(\n.{0,46})?(\n.{0,46})?(\n.{0,46})?\n?$/
export const emailRegx = /^(?=.{1,64}@)[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/
export const postalCodeRegex = /^[a-zA-Z0-9]*[\- ]?[a-zA-Z0-9]*$/